<template>
  <modal-layout id="personal_information">
    <popup-privacy-consent @dispose="onDispose" />
  </modal-layout>
</template>

<script>
import ModalLayout from '@/components/global/ModalLayout.vue';
import modalMixin from '@/components/global/modal-mixin';
import PopupPrivacyConsent from '@/components/modal-popups/PopupPrivacyConsent.vue';

export default {
  name: 'ModalReservation',
  components: {
    ModalLayout,
    PopupPrivacyConsent,
  },
  mixins: [modalMixin],
  data() {
    return {
      temp: false,
    };
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/modal-popups/ModalPrivacyConsent.vue